const initState = {
  leads: [],
  leadPage: 1,
  leadLimit: 10,
  leadCount: 0,
  openLeadModal: false,
  openLeadFollowUpModal: false,
  openQuotationModal: false,
  openConvertToSaleModal: false,
  leadInfo: null,
  leadFollowUps: [],
  leadQuotations: [],
  linkedTo: {
    type: "none",
    id: "",
  },
  statics: {
    kpis: [],
    funnel: [],
    leadSources: [],
    packageInterest: [],
    staffPerformance: [],
  },
  userFollowUps: [],
};

const LeadReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_LEADS_DATA":
      return {
        ...state,
        leads: action.payload.data,
      };
    case "SET_LEAD_COUNT":
      return {
        ...state,
        leadCount: action.payload.data,
      };
    case "SET_LEAD_PAGE":
      return {
        ...state,
        leadPage: action.payload.data,
      };
    case "SET_LEAD_LIMIT":
      return {
        ...state,
        leadLimit: action.payload.data,
      };
    case "SET_OPEN_LEAD_MODAL":
      return {
        ...state,
        openLeadModal: action.payload.data,
      };
    case "SET_OPEN_LEAD_FOLLOWUP_MODAL":
      return {
        ...state,
        openLeadFollowUpModal: action.payload.data,
      };
    case "SET_OPEN_QUOTATION_MODAL":
      return {
        ...state,
        openQuotationModal: action.payload.data,
      };
    case "SET_OPEN_CONVERT_TO_SALE_MODAL": {
      return {
        ...state,
        openConvertToSaleModal: action.payload.data,
      };
    }
    case "SET_LEAD_INFO":
      return {
        ...state,
        leadInfo: action.payload.data,
      };
    case "SET_LEAD_FOLLOWUPS":
      return {
        ...state,
        leadFollowUps: action.payload.data,
      };
    case "SET_LEAD_QUOTATIONS":
      return {
        ...state,
        leadQuotations: action.payload.data,
      };
    case "SET_LEAD_LINKED_TO": {
      return {
        ...state,
        linkedTo: action.payload.data,
      };
    }
    case "SET_LEAD_STATICS": {
      return {
        ...state,
        statics: action.payload.data,
      };
    }
    case "SET_USER_FOLLOWUPS": {
      return {
        ...state,
        userFollowUps: action.payload.data,
      };
    }
    default:
      return { ...state };
  }
};

export default LeadReducer;
